import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormData } from '../Utils/form-data';
import { InvestmentStrategyMainPage } from '../Utils/formdata.models';
import { DynamoService } from '../utils/dynamo.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-investment-strategy-main',
  templateUrl: './investment-strategy-main.component.html',
  styleUrls: ['./investment-strategy-main.component.css']
})
export class InvestmentStrategyMainComponent implements OnInit {
  formTwo: FormGroup;
  fundTypes;
  page = this.chooseFundType(this.formData.investmentStrategyMain.fundType);
  seedingOrAccelerationPartnership;
  contactWithSatori;
  isDataAvailable1 = false;
  isDataAvailable2 = false;
  isDataAvailable3 = false;
  nrSelect1:string = 'fundtype';
  nrSelect2:string = 'partnership';
  nrSelect3:string = 'preExistingContact';
  constructor(public formData: FormData, private dynamo: DynamoService, private router: Router) { }

  ngOnInit() {
    this.formData.investmentStrategyMain = new InvestmentStrategyMainPage();
    this.formTwo = this.formData.investmentStrategyMain.getFormGroup();
    if (this.formData.firmInformation.isDataValid()) {

      this.dynamo.getLookupName('L__SatoriSeedingAccPart').subscribe(data => {
        this.seedingOrAccelerationPartnership = data;
        this.isDataAvailable1 = true;
      }, error => {
        console.log('Lookup error: ', error);
      });
      this.dynamo.getLookupName('L_FundType').subscribe(data => {
        this.fundTypes = data;
        this.isDataAvailable2 = true;
      }, error => {
        console.log('Lookup error: ', error);
      });
      this.dynamo.getLookupName('L_YesNo').subscribe(data => {
        this.isDataAvailable3 = true;
        this.contactWithSatori = data;
      }, error => {
        console.log('Lookup error: ', error);
      });

    } else {
      this.router.navigate(['firm-information']);
    }

  }

  chooseFundType(event) {
    if (event === 'Open-end') {
      this.page = '/open-end-funds';
    }
    if (event === 'Closed-end') {
      this.page = '/closed-end-funds';
    }
    if (event === 'Other') {
      this.page = '/other-funds';
    }
    return this.page;
  }


  setProps() {
    this.formData.investmentStrategyMain.migrateFormData();
  }
}
